import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import ReactDatePicker from 'react-datepicker'

// Reducers
import {
  selectScheduleTourDate,
  setScheduleTourDate,
  setScheduleTourStepAdvanceOneStep,
  selectScheduleTourStep,
  setScheduleTourShowModal,
  setScheduleTourStep,
  STEPS,
  STEPS_CONST,
  STEPS_REA
} from '../../../../../../../../store/slices/scheduleTour'

// Components
import Step from '../../../../../ModalStepsOutline'
// Styles
import './When.scss'
import { selectCustomerIsRealEstateAgent } from '../../../../../../../../store/selectors/customerProfile'

export const When = () => {
  const dispatch = useDispatch()
  const selected = useSelector(selectScheduleTourDate)
  const currentStep = useSelector(selectScheduleTourStep)
  const stepIndex = STEPS.indexOf(currentStep)
  const isCustomerREA = useSelector(selectCustomerIsRealEstateAgent)

  const handleButtonClick = () => {
    dispatch(setScheduleTourStepAdvanceOneStep())
  }

  return (
    <Step stepLabel='schedule-tour-date'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={isCustomerREA ? STEPS_REA : STEPS}
        onCancel={() => dispatch(setScheduleTourShowModal(false))}
        onBack={() => dispatch(setScheduleTourStep(STEPS_CONST[stepIndex - 1]))}
      />
      <Step.Title>
        <FormattedMessage id='ScheduleTour.When.Label' defaultMessage='When do you want to tour?' />
      </Step.Title>
      <Step.Body>
        <div className='when-step-react-date-picker'>
          <ReactDatePicker
            nextMonthButtonLabel=''
            previousMonthButtonLabel=''
            minDate={new Date()}
            onChange={(date: Date) => dispatch(setScheduleTourDate(date))}
            inline
            selected={selected}
          />
        </div>
      </Step.Body>
      <Step.FooterButton onClick={handleButtonClick}>
        <FormattedMessage id='ScheduleTour.FooterButton.NextStep' defaultMessage='Next Step' />
      </Step.FooterButton>
    </Step>
  )
}
